export enum PopupTypeEnum {
  LANDING_PAGE = 'LANDING_PAGE',
  DELIVERY = 'DELIVERY',
  COUPON = 'COUPON',
  PROMOTION = 'PROMOTION',
  CATEGORY = "CATEGORY",
  PRODUCT_DETAIL = "PRODUCT_DETAIL",
  // MERCHANT = 'MERCHANT'
}

export enum PopupSlideEnum {
  CATEGORY = "CATEGORY",
  PRODUCT_DETAIL = "PRODUCT_DETAIL",
  PROMOTION_FLASH_SALE = "PROMOTION_FLASH_SALE",
  // COUPON = "COUPON"
}
